
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genre/[alias]",
      function () {
        return require("private-next-pages/genre/[alias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genre/[alias]"])
      });
    }
  